import type { AlertType } from '@/types/alert.types.ts'
import type { CSSProperties } from 'react'

const TYPE_STYLES: Record<AlertType, CSSProperties> = {
  success: {
    background: 'var(--color-bg-elevated)',
    borderLeftColor: 'var(--color-success)',
    color: '#6ee7b7',
  },
  error: {
    background: 'var(--color-bg-elevated)',
    borderLeftColor: 'var(--color-error)',
    color: '#fca5a5',
  },
  warning: {
    background: 'var(--color-bg-elevated)',
    borderLeftColor: 'var(--color-warning)',
    color: '#fcd34d',
  },
  info: {
    background: 'var(--color-bg-elevated)',
    borderLeftColor: 'var(--color-info)',
    color: '#93c5fd',
  },
  debug: {
    background: 'var(--color-bg-elevated)',
    borderLeftColor: 'var(--color-debug)',
    color: '#9ca3af',
  },
}

export const alertItemStyles = {
  container: (type: AlertType): CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'var(--space-md)',
    borderRadius: 'var(--radius-md)',
    borderLeft: '4px solid',
    boxShadow: 'var(--shadow-lg)',
    marginBottom: 'var(--space-sm)',
    animation: 'alertSlideIn 0.3s ease-out',
    border: '1px solid var(--color-border)',
    ...TYPE_STYLES[type],
  }),
  message: {
    flex: 1,
    fontSize: '0.875rem',
    fontWeight: 500,
  } as CSSProperties,
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 'var(--space-xs)',
    marginLeft: 'var(--space-sm)',
    fontSize: '1.25rem',
    lineHeight: 1,
    opacity: 0.7,
    color: 'inherit',
  } as CSSProperties,
}
